/**
 * Validação e formatação de CPF/CNPJ.
 * Regras oficiais: dígitos verificadores por módulo 11. Sequências repetidas (ex.: 111.111.111-11) são inválidas.
 */
/** Remove tudo que não é dígito. */
export function normalizarDocumento(valor) {
    return valor.replace(/\D/g, '');
}
function digitoVerificador(digitos, pesos) {
    const soma = digitos.reduce((acc, d, i) => acc + d * (pesos[i] ?? 0), 0);
    const resto = soma % 11;
    return resto < 2 ? 0 : 11 - resto;
}
export function validarCpf(valor) {
    const cpf = normalizarDocumento(valor);
    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf))
        return false;
    const d = cpf.split('').map(Number);
    const dv1 = digitoVerificador(d.slice(0, 9), [10, 9, 8, 7, 6, 5, 4, 3, 2]);
    const dv2 = digitoVerificador(d.slice(0, 10), [11, 10, 9, 8, 7, 6, 5, 4, 3, 2]);
    return d[9] === dv1 && d[10] === dv2;
}
export function validarCnpj(valor) {
    const cnpj = normalizarDocumento(valor);
    if (cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj))
        return false;
    const d = cnpj.split('').map(Number);
    const dv1 = digitoVerificador(d.slice(0, 12), [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
    const dv2 = digitoVerificador(d.slice(0, 13), [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
    return d[12] === dv1 && d[13] === dv2;
}
/** Identifica o tipo pelo tamanho e valida os dígitos. Retorna null se inválido. */
export function identificarDocumento(valor) {
    const doc = normalizarDocumento(valor);
    if (doc.length === 11 && validarCpf(doc))
        return 'cpf';
    if (doc.length === 14 && validarCnpj(doc))
        return 'cnpj';
    return null;
}
/**
 * Como {@link formatarDocumento}, mas aceita a ausência de documento.
 *
 * Nem todo cadastro tem um: o técnico de liberação entra pelo mesmo chat, com conta
 * própria, e não é cliente da Maxx.
 */
export function formatarDocumentoOuNulo(valor) {
    return valor ? formatarDocumento(valor) : null;
}
export function formatarDocumento(valor) {
    const doc = normalizarDocumento(valor);
    if (doc.length === 11)
        return doc.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    if (doc.length === 14)
        return doc.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    return valor;
}
/** Máscara para exibição a perfis sem permissão completa: 123.***.***-45 ou 12.***.***\/****-90 */
export function mascararDocumento(valor) {
    const doc = normalizarDocumento(valor);
    if (doc.length === 11)
        return `${doc.slice(0, 3)}.***.***-${doc.slice(9)}`;
    if (doc.length === 14)
        return `${doc.slice(0, 2)}.***.***/****-${doc.slice(12)}`;
    return '***';
}
//# sourceMappingURL=documento.js.map